var map = {
	"./bbc54yyk/logo.svg": 992,
	"./chaoxinxing/logo.svg": 994,
	"./ecshopx/logo.svg": 996,
	"./onex/logo.svg": 1003,
	"./yyk/logo.svg": 1005
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/logo\.svg$
// module id = 46
// module chunks = 30